import { render } from "./CompanyEdit.vue?vue&type=template&id=3068af23&scoped=true"
import script from "./CompanyEdit.vue?vue&type=script&lang=js"
export * from "./CompanyEdit.vue?vue&type=script&lang=js"

import "./CompanyEdit.vue?vue&type=style&index=0&id=3068af23&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3068af23"]])

export default __exports__